//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    // required
    link: {
      type: String,
      required: true
    },
    // optional
    append: {
      type: Boolean,
      required: false,
      default: false
    },
    exact: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    textColorClass: {
      type: String,
      required: false,
      default: 'text-blue-800'
    }
  },
  computed: {
    hasSlotData() {
      return this.$slots.default
    }
  }
}
